import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCreditCardAdd"><Path d="M2 4.00293H21.99L21.9922 4.75075C21.9964 6.18525 21.9962 7.61979 21.9961 9.05303L21.9961 12H17V15H14V19.9961H2V10.5H21.9961V9H2V4.00293Z" fill="currentColor"/><Path d="M23 16.5H20V13.5H18.5V16.5H15.5V18H18.5V21H20V18H23V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCardAdd;
